module.exports = __webpack_public_path__ + "img/003.a1bc0c4f.png";